import React, { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import Drawer from "@mui/material/Drawer";
import Button from "../UniversalComponents/DefaultButton";
import { ReactComponent as OverDueAmountIcon } from "../../assets/images/overDueAmountIcon.svg";
import { ReactComponent as OpenBillsIcon } from "../../assets/images/openBillsIcon.svg";
import { ReactComponent as PaidDollarIcon } from "../../assets/images/paidDollarIcon.svg";
import CustomerHeaderHoc from "./CustomerHeaderHoc";
import NewClient from "./NewClient";

const AddClient = () => {
  const [isAddClientVisible, setIsAddClientVisible] = useState(false);

  const handleNewClientClick = () => {
    setIsAddClientVisible((prev) => !prev); // Toggle visibility
  };

  const closeAddVendor = () => {
    setIsAddClientVisible(false); // Hide the AddVendor component
  };
  return (
    <div className="flex flex-col gap-y-3 mx-10">
      <div className="flex justify-end">
        {isAddClientVisible && (
          <div className="">
            <Drawer
              anchor="right"
              open={isAddClientVisible}
              onClose={closeAddVendor}
              sx={{
                "& .MuiDrawer-paper": {
                  height: "calc(100% - 20px)",
                  bottom: "20px",
                  width: "40%",
                },
              }}
            >
              <div className="w-100per">
                <NewClient />
              </div>
            </Drawer>
          </div>
        )}
      </div>
      <div className="w-full flex space-x-2">
        <div className="w-full flex gap-x-2">
          <div className="w-full  border border-CACACA  flex justify-start items-center bg-FFFFFF">
            <div className="p-2  w-full rounded">
              <div className="flex gap-x-2 justify-start items-center">
                <span>
                  <OverDueAmountIcon />
                </span>

                <div className="flex flex-col ">
                  <span className="text-16 font-600 p-[2px]">$ 5,000,00</span>
                  <span className="text-12 font-400 p-[2px]"> 0 Estimates</span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex bg-FFFFFF ">
            <div className="p-2 border border-CACACA w-full rounded">
              <div className=" flex gap-x-2 justify-start items-center">
                <span>
                  <OpenBillsIcon />
                </span>

                <div className="flex flex-col">
                  <span className="text-16 font-600">$ 5,000,00</span>
                  <span className="text-12 font-400">Unbilled Income</span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-start items-center bg-FFFFFF border border-CACACA">
            <div className="p-2  w-full rounded">
              <div className="flex gap-x-2 justify-start items-center">
                <span>
                  <PaidDollarIcon />
                </span>

                <div className="flex flex-col ">
                  <span className="text-16 font-600 p-[2px]">$ 5,000,00</span>
                  <span className="text-12 font-400 p-[2px]">0 Overdue Invoices</span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex bg-FFFFFF ">
            <div className="p-2 border  border-CACACA w-full rounded">
              <div className=" flex gap-x-2 justify-start items-center">
                <span>
                  <PaidDollarIcon />
                </span>

                <div className="flex flex-col">
                  <span className="text-16 font-600">$ 5,000,00</span>
                  <span className="text-12 font-400">0 Open invoices and Credits</span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex bg-FFFFFF ">
            <div className="p-2 border border-CACACA w-full rounded">
              <div className=" flex gap-x-2 justify-start items-center">
                <span>
                  <PaidDollarIcon />
                </span>

                <div className="flex flex-col">
                  <span className="text-16 font-600">$ 5,000,00</span>
                  <span className="text-12 font-400">0 Recently Paid</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="text-20 text-203C50 font-600">Client Listing</div>

        <div>
          <Button
            type="primary"
            onClick={handleNewClientClick}
            style={{
              margin: "1px",
              padding: "5px",
              height: "35px",
              borderRadius: "8px",
            }}
          >
            New Client
          </Button>
        </div>
      </div>
      <div className>
        {/* <table className="w-full  text-sm text-left text-gray-500 border-b border-gray-200 rounded-md bg-white">
          <thead className="bg-white">
            <tr className="text-12 font-400 text-1D4469">
              {["# ", "Category :", "Description", "Amount", "Client", "Action"].map((header, i) => (
                <th key={i} className="px-4 py-2 text-gray-700 font-semibold">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
        </table> */}
        <div>table not available</div>
      </div>
    </div>
  );
};

export default LayoutHOC(CustomerHeaderHoc(AddClient));
